import {
  ColumnFiltersState,
  ColumnOrderState,
  ColumnSizingState,
  ExpandedState,
  GroupingState,
  SortingState,
  VisibilityState,
} from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { usePositionGroups } from '@paradigm/features/src/positions/contexts/position-groups';
import { TableSettings } from '@paradigm/design-system/src/components/Table';
import {
  useSelectedPositionRowsView,
  useSelectedPositionRowsActions,
} from '@paradigm/features/src/positions/contexts/selected-positions';

const defatulSorting = [
  {
    id: 'account_name',
    desc: false,
  },
  {
    id: 'product',
    desc: false,
  },
  {
    id: 'expires_at',
    desc: false,
  },
  {
    id: 'strike',
    desc: false,
  },
  {
    id: 'option_kind',
    desc: true,
  },
];

const initialVisibility = {
  expires_at: false,
  strike: false,
  option_kind: false,
  account_name: false,
};

export function usePositionTableSettings({
  defaultColumns,
}: {
  defaultColumns: ColumnOrderState;
}) {
  const { selectedGroups } = usePositionGroups();

  const { selectedRows } = useSelectedPositionRowsView();
  const { setSelectedRows } = useSelectedPositionRowsActions();
  const sorting = useState<SortingState>(defatulSorting);
  const grouping = useState<GroupingState>(selectedGroups);
  const filtering = useState<ColumnFiltersState>([]);
  const searching = useState<string>('');
  const ordering = useState<ColumnOrderState>(defaultColumns);
  const sizing = useState<ColumnSizingState>({});
  const visibility = useState<VisibilityState>(initialVisibility);
  const expanding = useState<ExpandedState>(true);
  const [_group, setGrouping] = grouping;
  const selected = [selectedRows, setSelectedRows] as const;

  useEffect(() => {
    setGrouping(selectedGroups);
  }, [selectedGroups, setGrouping]);

  const settings: TableSettings = {
    searching,
    filtering,
    grouping,
    sorting,
    ordering,
    sizing,
    selected,
    visibility,
    expanding,
  };

  return {
    settings,
    sorting,
    grouping,
    filtering,
    ordering,
    sizing,
    selected,
    visibility,
    expanding,
  };
}

export default usePositionTableSettings;
